import styled from "styled-components";
import { device } from "utils/devices";

export const Container = styled.div`
  height: 120px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.tertiary};
  margin: 10px 10px 0 10px;

  * {
    margin: 0 10px 0 40px;
  }

  img {
    border-radius: 50%;
    width: auto;
    height: 100px;
  }

  a {
    font-weight: 600;
    letter-spacing: 1px;
    text-decoration: none;
    color: #fff;
    padding: 15px 20px;
    border-radius: 5px;
    background-color: ${(props) => props.theme.tertiary};

    &.active {
      background-color: ${(props) => props.theme.secondary};
    }
  }

  @media ${device.tablet} {
    * {
      margin-left: 10px;
    }

    img {
      height: auto;
      width: 80px;
    }

    a {
      padding: 10px 14px;
      font-size: 0.8em;
      font-weight: 400;
    }
  }
`;
